import FeaturesAlertDialog from './FeaturesAlertDialog';

export default FeaturesAlertDialog;
